<template>
  <div id="service-specialist">
    <div id="top">
      <p style="font-size: 3.2vw;">服务专员</p>
      <p style="font-size: 2.933vw;">订单编号: {{orderNum}}</p>
    </div>
    <div id="bottom">
      <div class="left">
        <p>{{staffName}}</p>
        <p>工号: {{workCode}}</p>
      </div>
      <div class="line"></div>
      <div class="right" @click="call">
        <img src="images/AAV/phone.png" alt="">
        <p>电话</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "serviceSpecialist",
    props: {
      orderNum:{type: String, default: '--------------'},
      staffName:{type: String, default: '一 一 一'},
      workCode:{type: String, default: '------'},
      staffPhone:{type: String, default: '-----------'}
    },
    methods:{
      call() {
        this.$dialog.confirm({
          title:'提示',
          message: `确定拨打电话: \n${this.staffPhone}`
        }).then(() => {
          window.location.href = `tel://${this.staffPhone}`;
        }).catch(() => {
          // catch
        });
      },
    },
  }
</script>

<style scoped>
  #service-specialist{
    width: 92vw;
    height: 25.6vw;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 2.667vw 3.2vw;
    background: white;
    border-radius: 1.333vw;
  }
  #top{
    color: #909399;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 2vw;
    border-bottom: 1px solid #edeff2;
  }
  #bottom{
    margin-top: 4vw;
    display: flex;
    align-items: center;
  }
  #bottom>.left{flex: 1}
  /*#bottom>.line{flex: 0}*/
  #bottom>.right{margin: 0 2vw 0 5.333vw}
  #bottom>.left>p:first-child{
    font-size: 4.267vw;
    color: #303133;
  }
  #bottom>.left>p:last-child{
    margin-top: 2vw;
    font-size: 3.467vw;
    color: #909399;
  }
  #bottom .line{
    width: 1px;
    height: 5.333vw;
    background-color: #bfc2cc;
  }
  #bottom>.right>img{
    width: 5.333vw;
    height: 5.333vw;
    object-fit: contain;
  }
  #bottom>.right>p{
    font-size: 2.933vw;
    color: #909399;
  }
</style>
